export default {
  lastModification: 'Última modificación:',
  createdBy: 'Creado por:',
  on: 'el',
}
